import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  IconButton,
  Typography,
  Box,
} from "@mui/material";
import logo from "../assets/logo.png";

import LockIcon from "@mui/icons-material/Lock";
import CloseIcon from "@mui/icons-material/Close";
import toastAlert from "./toastAlert";

function AccessCodeDialog({
  accessCodeModal,
  accessCodeSigner,
  accessCodeModalData,
}) {
  const [open, setOpen] = useState(false);
  const [inputCode, setInputCode] = useState("");
  const [signerAccessCode, setSignerAccessCode] = useState("");
  useEffect(() => {
    setOpen(accessCodeModal);
    setSignerAccessCode(accessCodeSigner);
  }, [accessCodeModal, accessCodeSigner]);

  //   useEffect(() => {
  //     if (apiData?.accessCode === true || apiData?.accessCode === "true") {
  //       console.log("Access code true ");
  //       setSignerAccessCode(apiData?.data?.access_code);
  //       setOpen(true);
  //     } else {
  //       console.log("Access code false ");
  //     }
  //   }, [apiData]);

  const handleClose = () => {
    setOpen(false);
  };

  const handleSubmit = () => {
    if (inputCode === signerAccessCode) {
      //   alert("Access Code Validated!");
      toastAlert("success", "Access Code Validated!");

      setOpen(false);
      accessCodeModalData(false);
    } else {
      //   alert("Invalid Access Code. Please try again.");
      toastAlert("error", "Invalid Access Code. Please try again.");
    }
  };

  return (
    <Dialog
      open={open}
      //   onClose={handleClose}
      fullWidth
      maxWidth="xs"
      fullScreen={window.innerWidth < 780 ? true : false}
      PaperProps={{
        style: {
          backgroundColor: "white",
          borderRadius: 16,
          padding: "16px",
          zIndex: 20000, // Ensure modal appears above text fields (10000+)
        },
      }}
      BackdropProps={{
        style: { 
          backgroundColor: "rgba(0, 0, 0, 0.7)",
          zIndex: 19999, // Backdrop should be just below modal
        },
      }}
      sx={{
        zIndex: 20000, // Ensure Dialog container is above text fields
      }}
    >
      {window.innerWidth < 780 && (
        <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
          <img
            src={logo} // Make sure 'logo' is defined
            alt="E-Sign Logo"
            style={{ width: "120px", height: "auto" }}
          />
        </Box>
      )}
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "16px 24px",
          //   borderBottom: "1px solid #e0e0e0",
        }}
      >
        <Typography
          variant="h6"
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1.5,
            color: "#1a237e",
            fontWeight: 600,
            fontSize: "1.25rem",
          }}
        >
          <LockIcon sx={{ color: "#1976d2" }} />
          Access Code Required
        </Typography>
        {/* <IconButton
          onClick={handleClose}
          sx={{
            color: "rgba(0, 0, 0, 0.54)",
            "&:hover": {
              backgroundColor: "rgba(0, 0, 0, 0.04)",
            },renderImage
          }}
        >
          <CloseIcon />
        </IconButton> */}
      </DialogTitle>

      <DialogContent sx={{ padding: "24px", paddingBottom: "32px" }}>
        <Typography
          variant="body1"
          sx={{
            mb: 3,
            color: "rgba(0, 0, 0, 0.67)",
            lineHeight: 1.5,
          }}
        >
          This document is protected. Please enter the access code provided by
          the sender to view the document.
        </Typography>
        <TextField
          label="Access Code"
          variant="outlined"
          fullWidth
          value={inputCode}
          onChange={(e) => setInputCode(e.target.value)}
          autoFocus
          sx={{
            "& .MuiOutlinedInput-root": {
              "&:hover fieldset": {
                borderColor: "#1976d2",
              },
              "&.Mui-focused fieldset": {
                borderColor: "#1976d2",
              },
            },
            "& .MuiInputLabel-root.Mui-focused": {
              color: "#1976d2",
            },
          }}
          InputProps={{
            sx: { borderRadius: 1 },
          }}
        />
      </DialogContent>

      <DialogActions
        sx={{
          padding: "10px 24px",
          //   borderTop: "1px solid #e0e0e0",
          //   gap: 2,
        }}
      >
        {/* <Button
          onClick={handleClose}
          sx={{
            color: "rgba(0, 0, 0, 0.87)",
            "&:hover": {
              backgroundColor: "rgba(0, 0, 0, 0.04)",
            },
            fontWeight: 500,
            textTransform: "none",
            minWidth: "100px",
          }}
        >
          Cancel
        </Button> */}
        <Button
          onClick={handleSubmit}
          variant="contained"
          sx={{
            backgroundColor: "#1976d2",
            boxShadow: "none",
            "&:hover": {
              backgroundColor: "#1565c0",
              boxShadow: "none",
            },
            fontWeight: 500,
            textTransform: "none",
            minWidth: "100px",
          }}
        >
          Continue
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default AccessCodeDialog;
